import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme.js';
import { connect } from 'react-redux';

import { request, guid, mapStateToProps, mapDispatchToProps, intersection } from '../../utils';
import { fetchFeaturedPosts } from '../../actions/content';

import Body from '../../components/Body';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContentContainer from '../../components/ContentContainer';
import HeaderSlider from '../../components/HeaderSlider';
import HorizontalRule from '../../components/HorizontalRule';
import FilterControl from '../../components/FilterControl';
import ArticleSummary from '../../components/ArticleSummary';
import NewsletterCTA from '../../components/NewsletterCTA';
import LoadMore from '../../components/LoadMore';
import BodyAd from '../../components/BodyAd';

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

class Music extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: null,
      filters: [],
    };
  }

  _handleFilter(category) {
    if(category) {
      category = category.toLowerCase();

      if(category === 'all') {
        this.setState({
          filters: [],
        });
      } else {
        const existingFilters = this.state.filters;
        this.setState({
          filters: ['nothing'],
        });
        setTimeout(() => {
          // If state contains this category
          if(existingFilters.indexOf(category) != -1) {
            // Remove from state
            this.setState({
              filters: existingFilters.filter(cat => cat !== category),
            });
          } else {
            this.setState({
              filters: [].concat(existingFilters, [category]),
            });
          }

          setTimeout(() => {
            // Load more pages if necessary
            if(this.props.content.featured.page < this.props.content.featured.max_num_pages) {
              const numPosts = this.getPosts().length;
              if(numPosts < 6) {
                this._loadMorePosts();
              }
            }
          }, 200);
        }, 0);
      }
    }
  }

  getFeaturedPosts() {
    if(this.props.content.featured.posts.length > 0) {
      return this.props.content.featured.posts.filter((post) => {
        if (post.featured) {
          return true;
        }

        return false;
      }).slice(0,1);
    }

    return false;
  }

  getPosts() {
    const posts = this.props.content.featured.posts;
    const renderedPosts = [];

    if(posts.length > 0) {
      posts.filter((post) => {
        const postCategories = post.categories.map(v => v.toLowerCase());
        const categoriesIntersection = intersection(this.state.filters, postCategories);

        if(!this.state.filters.length || (postCategories && categoriesIntersection.length)) {
          return true;
        }
      }).map((post, index) => {
        if(index === 6) {
          renderedPosts.push(
            <BodyAd ads={this.props.content.ads} />
          );
        } else if(index > 0 && index % 6 === 0 && index % 12) {
          renderedPosts.push(
            <BodyAd ads={this.props.content.ads} />
          );
        }
        renderedPosts.push(
          <ArticleSummary
            key={`${post.id}_${post.slug}`}
            post={post} />
        );
      });

      return renderedPosts;
    }

    return false;
  }

  _loadMorePosts() {
    this.props.dispatch(fetchFeaturedPosts(this.props.content.featured.page + 1));
  }

  render() {
    const featuredPosts = this.getFeaturedPosts();
    const posts = this.getPosts();

    return (
      <Body
        title="Features - Sniffers"
        history={this.props.history}
        player={this.props.player}
        search={this.props.search}
        dispatch={this.props.dispatch}>
        <Header content={this.props.content} dispatch={this.props.dispatch} />
        <ContentContainer>
          <div className={css(styles.content_container)}>
            <div className={css(styles.page_title)}>
              Features.
            </div>
            {
              this.props.content.loaded ? (
                <div>
                  {
                    posts && featuredPosts && featuredPosts.length ? (
                      <div className={css(styles.slider_container)}>
                        <HeaderSlider articles={featuredPosts} />
                      </div>
                    ) : false
                  }
                  <div className={css(styles.horizontal_rule)}>
                    <HorizontalRule />
                  </div>
                  <FilterControl
                    active={this.state.filter}
                    filters={this.state.filters}
                    handler={this._handleFilter.bind(this)} />
                  <div className={css(styles.articles_container)}>
                    { posts }
                    { posts ? (
                      <LoadMore
                        page={this.props.content.featured.page}
                        visible={this.props.content.featured.page < this.props.content.featured.max_num_pages}
                        handler={this._loadMorePosts.bind(this)} />
                    ) : false}
                  </div>
                </div>
              ) : false
            }
          </div>
        </ContentContainer>
        {
          this.props.content.loaded ? (
            <div>
              <NewsletterCTA dispatch={this.props.dispatch} />
              <Footer />
            </div>
          ) : false
        }
      </Body>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Music);

const styles = StyleSheet.create({
  page_title: {
    fontFamily: Theme.fontFamily,
    fontWeight: '900',
    fontSize: 48,
    marginTop: 40,
    marginBottom: 40,
  },
  slider_container: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  content_container: {
    width: Theme.container_width - (Theme.margin_width * 2),
    margin: '0 auto',
    paddingTop: 20,
    paddingBottom: 20,
    flexDirection: 'column',
    [Theme.mobile_query]: {
      width: '90%',
    }
  },
  horizontal_rule: {
  },
  articles_container: {
    marginTop: 40,
    marginBottom: 100,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: "wrap"
  }
});



// WEBPACK FOOTER //
// ./src/views/Featured/index.js